import { render, staticRenderFns } from "./VipPurchaseSuccessToast.vue?vue&type=template&id=298687f6&scoped=true&"
import script from "./VipPurchaseSuccessToast.vue?vue&type=script&lang=ts&"
export * from "./VipPurchaseSuccessToast.vue?vue&type=script&lang=ts&"
import style0 from "./VipPurchaseSuccessToast.scss?vue&type=style&index=0&id=298687f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298687f6",
  null
  
)

export default component.exports